import { render, staticRenderFns } from "./KnowPageDetail.vue?vue&type=template&id=1d164f70&scoped=true"
import script from "./KnowPageDetail.vue?vue&type=script&lang=js"
export * from "./KnowPageDetail.vue?vue&type=script&lang=js"
import style0 from "./KnowPageDetail.vue?vue&type=style&index=0&id=1d164f70&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1d164f70",
  null
  
)

export default component.exports